/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantPlatformStoragePolicyResponse
 */
export interface TenantPlatformStoragePolicyResponse {
    /**
     * 
     * @type {string}
     * @memberof TenantPlatformStoragePolicyResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantPlatformStoragePolicyResponse
     */
    optedIn?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TenantPlatformStoragePolicyResponse
     */
    retentionDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantPlatformStoragePolicyResponse
     */
    effectiveRetentionDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantPlatformStoragePolicyResponse
     */
    platformDefaultRetentionDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantPlatformStoragePolicyResponse
     */
    maxOptInRetentionDays?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantPlatformStoragePolicyResponse
     */
    billingAttestationAccepted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TenantPlatformStoragePolicyResponse
     */
    billingAttestationAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TenantPlatformStoragePolicyResponse
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the TenantPlatformStoragePolicyResponse interface.
 */
export function instanceOfTenantPlatformStoragePolicyResponse(value: object): value is TenantPlatformStoragePolicyResponse {
    return true;
}

export function TenantPlatformStoragePolicyResponseFromJSON(json: any): TenantPlatformStoragePolicyResponse {
    return TenantPlatformStoragePolicyResponseFromJSONTyped(json, false);
}

export function TenantPlatformStoragePolicyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantPlatformStoragePolicyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'optedIn': json['optedIn'] == null ? undefined : json['optedIn'],
        'retentionDays': json['retentionDays'] == null ? undefined : json['retentionDays'],
        'effectiveRetentionDays': json['effectiveRetentionDays'] == null ? undefined : json['effectiveRetentionDays'],
        'platformDefaultRetentionDays': json['platformDefaultRetentionDays'] == null ? undefined : json['platformDefaultRetentionDays'],
        'maxOptInRetentionDays': json['maxOptInRetentionDays'] == null ? undefined : json['maxOptInRetentionDays'],
        'billingAttestationAccepted': json['billingAttestationAccepted'] == null ? undefined : json['billingAttestationAccepted'],
        'billingAttestationAt': json['billingAttestationAt'] == null ? undefined : (new Date(json['billingAttestationAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function TenantPlatformStoragePolicyResponseToJSON(json: any): TenantPlatformStoragePolicyResponse {
    return TenantPlatformStoragePolicyResponseToJSONTyped(json, false);
}

export function TenantPlatformStoragePolicyResponseToJSONTyped(value?: TenantPlatformStoragePolicyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'optedIn': value['optedIn'],
        'retentionDays': value['retentionDays'],
        'effectiveRetentionDays': value['effectiveRetentionDays'],
        'platformDefaultRetentionDays': value['platformDefaultRetentionDays'],
        'maxOptInRetentionDays': value['maxOptInRetentionDays'],
        'billingAttestationAccepted': value['billingAttestationAccepted'],
        'billingAttestationAt': value['billingAttestationAt'] == null ? undefined : ((value['billingAttestationAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

